import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppointmentPayload } from '@maximizer/actions/domain';
import { LocaleService } from '@maximizer/core/shared/data-access';
import { ActionRowResultComponent } from './action-row-result.component';
import { AppointmentFormatter, appointmentWhen } from './appointment-when';

@Component({
  selector: 'maximizer-action-card-appointment',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, ActionRowResultComponent],
  templateUrl: './action-card-appointment.component.html',
})
export class ActionCardAppointmentComponent {
  readonly payload = input.required<AppointmentPayload>();

  // Unused, but the shell passes `editable` to every body.
  readonly editable = input<readonly string[]>([]);

  private readonly locale = inject(LocaleService);

  private readonly format: AppointmentFormatter = {
    date: (value) => this.locale.formatDateUserLocale(value),
    time: (value) => this.locale.formatTimeUserLocale(value),
  };

  protected readonly rows = computed(() =>
    (this.payload().items ?? []).map((row) => ({
      row,
      when: appointmentWhen(row.display.start, row.display.end, this.format),
      attendees: (row.display.with ?? []).join(', '),
    })),
  );
}
